import React from 'react';
import { Alert } from '@mui/material';

import { ActionTemplate } from './types';
import { ActionTemplateCard } from './ActionTemplateCard/ActionTemplateCard';

export const ActionTemplatesList = ({
  actionTemplates,
  loading,
}: {
  actionTemplates: ActionTemplate[];
  loading: boolean;
}) => (
  <>
    {!loading && actionTemplates.length === 0 ? (
      <Alert severity="info">
        No results found matching your search criteria. Please adjust your filters or search
        criteria and try again.
      </Alert>
    ) : null}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: '1fr',
        gridColumnGap: '30px',
        gridRowGap: '30px',
      }}
    >
      {actionTemplates.map((actionTemplate) => (
        <ActionTemplateCard key={actionTemplate.id} actionTemplate={actionTemplate} />
      ))}
    </div>
  </>
);
